import {
  createTaxGroup as publicCreateTaxGroup,
  getTaxGroup as publicGetTaxGroup,
  updateTaxGroup as publicUpdateTaxGroup,
  deleteTaxGroup as publicDeleteTaxGroup,
  queryTaxGroups as publicQueryTaxGroups,
  listDefaultTaxGroups as publicListDefaultTaxGroups,
  listDefaultTaxGroupsByAppIds as publicListDefaultTaxGroupsByAppIds,
} from './billing-v1-tax-group-tax-groups.public.js';
import { createRESTModule } from '@wix/sdk-runtime/rest-modules';
import { createEventModule } from '@wix/sdk-runtime/event-definition-modules';
import { BuildRESTFunction, MaybeContext } from '@wix/sdk-types';
import { onTaxGroupCreated as publicOnTaxGroupCreated } from './billing-v1-tax-group-tax-groups.public.js';
import { onTaxGroupDeleted as publicOnTaxGroupDeleted } from './billing-v1-tax-group-tax-groups.public.js';
import { onTaxGroupUpdated as publicOnTaxGroupUpdated } from './billing-v1-tax-group-tax-groups.public.js';

export const createTaxGroup: MaybeContext<
  BuildRESTFunction<typeof publicCreateTaxGroup> & typeof publicCreateTaxGroup
> = /*#__PURE__*/ createRESTModule(publicCreateTaxGroup);
export const getTaxGroup: MaybeContext<
  BuildRESTFunction<typeof publicGetTaxGroup> & typeof publicGetTaxGroup
> = /*#__PURE__*/ createRESTModule(publicGetTaxGroup);
export const updateTaxGroup: MaybeContext<
  BuildRESTFunction<typeof publicUpdateTaxGroup> & typeof publicUpdateTaxGroup
> = /*#__PURE__*/ createRESTModule(publicUpdateTaxGroup);
export const deleteTaxGroup: MaybeContext<
  BuildRESTFunction<typeof publicDeleteTaxGroup> & typeof publicDeleteTaxGroup
> = /*#__PURE__*/ createRESTModule(publicDeleteTaxGroup);
export const queryTaxGroups: MaybeContext<
  BuildRESTFunction<typeof publicQueryTaxGroups> & typeof publicQueryTaxGroups
> = /*#__PURE__*/ createRESTModule(publicQueryTaxGroups);
export const listDefaultTaxGroups: MaybeContext<
  BuildRESTFunction<typeof publicListDefaultTaxGroups> &
    typeof publicListDefaultTaxGroups
> = /*#__PURE__*/ createRESTModule(publicListDefaultTaxGroups);
export const listDefaultTaxGroupsByAppIds: MaybeContext<
  BuildRESTFunction<typeof publicListDefaultTaxGroupsByAppIds> &
    typeof publicListDefaultTaxGroupsByAppIds
> = /*#__PURE__*/ createRESTModule(publicListDefaultTaxGroupsByAppIds);
/**
 * Triggered when a tax group is created.
 */
export const onTaxGroupCreated: ReturnType<
  typeof createEventModule<typeof publicOnTaxGroupCreated>
> = createEventModule(publicOnTaxGroupCreated);
/**
 * Triggered when a tax group is deleted.
 */
export const onTaxGroupDeleted: ReturnType<
  typeof createEventModule<typeof publicOnTaxGroupDeleted>
> = createEventModule(publicOnTaxGroupDeleted);
/**
 * Triggered when a tax group is updated.
 */
export const onTaxGroupUpdated: ReturnType<
  typeof createEventModule<typeof publicOnTaxGroupUpdated>
> = createEventModule(publicOnTaxGroupUpdated);

export {
  SortOrder,
  WebhookIdentityType,
} from './billing-v1-tax-group-tax-groups.universal.js';
export {
  TaxGroup,
  CreateTaxGroupRequest,
  CreateTaxGroupResponse,
  GetTaxGroupRequest,
  GetTaxGroupResponse,
  UpdateTaxGroupRequest,
  UpdateTaxGroupResponse,
  DeleteTaxGroupRequest,
  DeleteTaxGroupResponse,
  QueryTaxGroupsRequest,
  QueryV2,
  QueryV2PagingMethodOneOf,
  Sorting,
  Paging,
  CursorPaging,
  QueryTaxGroupsResponse,
  CursorPagingMetadata,
  Cursors,
  ListDefaultTaxGroupsRequest,
  ListDefaultTaxGroupsResponse,
  ListDefaultTaxGroupsByAppIdsRequest,
  ListDefaultTaxGroupsByAppIdsResponse,
  ListDefaultTaxGroupsByAppIdsResult,
  ItemMetadata,
  ApplicationError,
  BulkActionMetadata,
  DomainEvent,
  DomainEventBodyOneOf,
  EntityCreatedEvent,
  RestoreInfo,
  EntityUpdatedEvent,
  EntityDeletedEvent,
  ActionEvent,
  MessageEnvelope,
  IdentificationData,
  IdentificationDataIdOneOf,
  TaxGroupNonNullableFields,
  CreateTaxGroupResponseNonNullableFields,
  GetTaxGroupResponseNonNullableFields,
  UpdateTaxGroupResponseNonNullableFields,
  QueryTaxGroupsResponseNonNullableFields,
  ListDefaultTaxGroupsResponseNonNullableFields,
  ListDefaultTaxGroupsByAppIdsResponseNonNullableFields,
  BaseEventMetadata,
  EventMetadata,
  TaxGroupCreatedEnvelope,
  TaxGroupDeletedEnvelope,
  TaxGroupUpdatedEnvelope,
  UpdateTaxGroup,
  TaxGroupsQueryResult,
  TaxGroupsQueryBuilder,
} from './billing-v1-tax-group-tax-groups.universal.js';
